import { Alert, Modal, Typography } from "@papercup-ai/orizuru";
import { UserNotice } from "../../utils/userNotice";

/**
 * Modal presentation of a user notice: blocks the page until acknowledged.
 * Driven by UserNotice, which owns the flag and the acknowledgement.
 * Rendered unconditionally and toggled with `open` so a Chakra dialog is
 * never unmounted while open (Zag ghost-layer leak).
 *
 * The button and Esc both acknowledge, so it can never get stuck.
 */
export const UserNoticeModal = ({
  notice,
  open,
  onAcknowledge
}: {
  notice: UserNotice | null;
  open: boolean;
  onAcknowledge: () => void;
}) => (
  <Modal
    open={open}
    onOpenChange={({ open: isOpen }) => {
      if (!isOpen) onAcknowledge();
    }}
    onConfirm={onAcknowledge}
    title={notice?.title ?? ""}
    confirmButtonLabel={"Got it"}
    cancelButtonHidden
    closeButton={false}
    closeOnInteractOutside={false}
    placement={"center"}
    hasOverlay
    draggable={false}
    resizable={false}
  >
    <Alert variant={"warning"} size={"block"}>
      {/* pre-line keeps line breaks ops put in the message */}
      <Typography variant={"labelMedium"} whiteSpace={"pre-line"}>
        {notice?.message}
      </Typography>
    </Alert>
  </Modal>
);
